import { render } from "./HelpFormReportABug.vue?vue&type=template&id=7767035e&scoped=true"
import script from "./HelpFormReportABug.vue?vue&type=script&lang=js"
export * from "./HelpFormReportABug.vue?vue&type=script&lang=js"

import "./HelpFormReportABug.vue?vue&type=style&index=0&id=7767035e&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7767035e"]])

export default __exports__